import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Upload from '@/pages/Upload';
import Documents from '@/pages/Documents';
import Batches from '@/pages/Batches';
import PDFs from '@/pages/PDFs';
import Users from '@/pages/Users';
import Audit from '@/pages/Audit';
import Admin from '@/pages/Admin';
import Duplicates from '@/pages/Duplicates';
import Layout from '@/components/Layout';
import { AuthProvider, useAuth } from '@/contexts/AuthContext';
import '@/App.css';

const PrivateRoute = ({ children }) => {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/*"
            element={
              <PrivateRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/upload" element={<Upload />} />
                    <Route path="/documents" element={<Documents />} />
                    <Route path="/batches" element={<Batches />} />
                    <Route path="/pdfs" element={<PDFs />} />
                    <Route path="/duplicates" element={<Duplicates />} />
                    <Route path="/users" element={<Users />} />
                    <Route path="/audit" element={<Audit />} />
                    <Route path="/admin" element={<Admin />} />
                  </Routes>
                </Layout>
              </PrivateRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthProvider>
  );
}

export default App;